import { createRoute } from '@tanstack/react-router'
import { appShellRoute } from '@/app/routes/_appShell'
import { validateChannelOnly } from '@/app/routes/_search'
import { RecoveryPage } from '@/features/recovery/pages/RecoveryPage'

/** ``/channels/:slug/recovery``: a página "Recuperar canal" de um canal. */
export const recoveryRoute = createRoute({
  getParentRoute: () => appShellRoute,
  path: '/channels/$slug/recovery',
  validateSearch: validateChannelOnly,
  component: RecoveryRoute,
})

function RecoveryRoute() {
  const { slug } = recoveryRoute.useParams()
  return <RecoveryPage slug={slug} />
}
